import { gql } from 'apollo-boost';
//import { useQuery } from 'react-apollo';
import { useQueryRefresh } from '..';
import { removeConnectionsMemoized } from '..';
import { uniqBy } from 'lodash';

const query = gql`
  query($investmentId: ID) {
    allInvestments(filters: {id: $investmentId}) {
      edges {
        node {
          reportDate1
          reportDate2
          reportDate3
          reportDate4
          reportDate5
          reportDate6
          timelineDays1
          timelineDays2
          timelineDays3
          timelineDays4
          timelineDays5
          timelineDays6
          timelineFrom1
          timelineFrom2
          timelineFrom3
          timelineFrom4
          timelineFrom5
          timelineFrom6
        }
      }
    }
  }
`;

const queryAll = gql`
  query {
    allInvestmentTags {
      edges {
        node { tag investmentId }
      }
    }
  }
`;

export const useContribution = (investmentId) => {
  // TODO: provisional fix to avoid issues with this query as it does not exist on beta-prod
  const isBeta = window.location.href.includes('beta');
  // eslint-disable-next-line no-constant-condition
  if (true) {
    return false;
  }
  const { data: rawData, refresh, isLoading } = useQueryRefresh(query, { investmentId });
  return {
    data: removeConnectionsMemoized(rawData?.allInvestments)?.[0],
    refresh,
    isLoading
  };
};
